import {
  ICO_HEADER_BYTES,
  OpenImageViewerShell,
  loadNativeImage,
  parseIcoHeader,
  readFileHeader,
  type OpenImageViewerConfig,
} from '@/features/open-image-viewer'
import { useT } from '@/shared/i18n'

export function IcoViewerPage() {
  const t = useT()
  const copy = t.icoViewer
  const config: OpenImageViewerConfig = {
    analyticsContext: {
      app: 'imgify',
      domain: 'imgify.ru',
      route: '/otkryt-ico',
      utility: 'ico-viewer',
      processingMode: 'local',
    },
    accept: '.ico,image/x-icon,image/vnd.microsoft.icon',
    acceptedMimeTypes: ['image/x-icon', 'image/vnd.microsoft.icon'],
    acceptedExtensions: ['.ico'],
    maxFileSizeBytes: 10 * 1024 * 1024,
    maxPixels: 4_000_000,
    formatLabel: 'ICO',
    previewBackground: 'checkerboard',
    validateFile: async (file) =>
      parseIcoHeader(await readFileHeader(file, ICO_HEADER_BYTES)) !== null,
    loadImage: async (file, signal) => {
      const sizes = parseIcoHeader(await readFileHeader(file, ICO_HEADER_BYTES)) ?? []
      const image = await loadNativeImage(file, config, copy, signal)
      return {
        ...image,
        facts: [
          {
            label: copy.storedSizes,
            value: sizes.map(({ width, height }) => `${width} x ${height}`).join(', '),
          },
        ],
      }
    },
    exportFormats: ['png', 'jpg'],
    exportNote: copy.exportNote,
    relatedTools: copy.relatedTools,
  }

  return <OpenImageViewerShell copy={copy} config={config} />
}
